import Navigation from '../../components/layout/Navigation';
import Footer from '../../components/layout/Footer';
import Hero from '../../components/ui/Hero';
import CTA from '../../components/ui/CTA';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import SocialSection from './components/SocialSection';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero 
        title={<>Let's Build Something <span className="gradient-text">Brilliant Together</span></>}
        description="Ready to transform your digital presence? We're eager to hear your ideas and discuss how Hash Adz can help you achieve your goals."
        bgImage="/assets/modern-office-reception.png"
        gradient="from-purple-900 via-purple-800 to-pink-800"
        primaryBtn={{ text: "Start Your Project", link: "#contact-form" }}
      />
      <ContactForm />
      <ContactInfo />
      <SocialSection />
      <CTA 
        title="Ready to Transform Your Digital Future?"
        description="Your next breakthrough is just a conversation away. Let's discuss how Hash Adz can elevate your digital presence."
        primaryBtn={{ text: "Start Your Project Today", link: "#contact-form", icon: "ri-rocket-line" }}
        gradient="from-purple-900 via-purple-800 to-pink-800"
      />
      <Footer />
    </div>
  );
}